// Typing "Red, Green, Blue" in a custom field's options box adds three options.

/**
 * Split typed text on commas into new option labels: each one trimmed, blanks
 * dropped, and anything already in `existing` (ignoring case) left out.
 */
export const splitOptionInput = (input, existing = []) => {
  const seen = new Set((existing || []).map((option) => String(option.value).toLowerCase()));
  const labels = [];

  String(input ?? '').split(',').forEach((part) => {
    const label = part.trim();
    const key = label.toLowerCase();
    if (!label || seen.has(key)) return;

    seen.add(key);
    labels.push(label);
  });

  return labels;
};

/** The "Add …" line shown in the menu while typing. */
export const createOptionLabel = (input, existing = []) => {
  const labels = splitOptionInput(input, existing);
  return labels.length > 1 ? `Add ${labels.length} options: ${labels.join(', ')}` : `Add "${labels[0] ?? input.trim()}"`;
};
